export const en = {
  // Top nav
  greeting: (firstName: string) => `Welcome to BugHerd, ${firstName}! 👋`,
  greetingShort: (firstName: string) => `Welcome, ${firstName}! 👋`,
  conciergeHelp: 'Need help getting set up?',
  conciergeHelpShort: 'Need help?',
  conciergeLink: 'Free concierge setup',
  conciergeLinkShort: 'Help',

  // Steps bar
  stepYourProject: 'Your project',
  stepInstall: 'Install BugHerd',
  stepTry: 'Try BugHerd',

  // Step 1 — Your project
  yourProjectHeading: 'Do you have a website ready to get feedback on?',
  yourProjectSubheading:
    "We'll set it up so you can start collecting feedback straight away.",
  hasWebsiteYesHeading: 'Yes, I have one 👍',
  hasWebsiteYesSubtext: 'Enter the URL below',
  hasWebsiteNoHeading: 'Not yet 🚧',
  hasWebsiteNoSubtext: "No problem! We'll use a demo site",
  projectUrlLabel: 'Enter your website URL 👇',
  projectUrlPlaceholder: 'myamazingwebsite.com',
  continue: 'Continue →',
  continueWithDemo: 'Continue with demo site',

  // Step 2 — Install BugHerd
  installHeading: "One quick step, then you're live",
  installSubheading:
    "After getting the browser extension or installing the Javascript code, you'll be able to click anything on your site and drop a feedback pin – no more emailing screenshots.",
  installExtensionTitle: (browser: string) => `${browser} extension`,
  installExtensionDescription: 'No code. Works on any website instantly.',
  installExtensionDisclaimerText: (storeName: string) =>
    `It's literally one click in the ${storeName} — then visit your site and BugHerd is there, ready to go.`,
  installJsTitle: 'Javascript code',
  installJsDescription:
    "Add it once and BugHerd is ready for you, your team and clients.",
  installJsDisclaimerText: "Paste the Javascript code in your website's <head> and BugHerd is ready for you, your team and clients.",

  // Step 2 — Install BugHerd (demo site variant)
  installDemoHeading: "You're ready to go on the demo site! 🎉",
  installDemoBody:
    "We've already set up BugHerd on the demo site for you — no install needed. We still recommend adding the browser extension so you can use BugHerd on your own websites later.",
  installDemoExtensionTitle: (browser: string) =>
    `Add the ${browser} extension`,
  installDemoExtensionDescription:
    'No code. Use BugHerd on any website you visit.',
  installDemoSkip: "I'll do this later",
    
  // Step 3 — Try BugHerd
  tryHeading: "You're all set! 🚀",
  trySubheading:
    'BugHerd is ready on your site. See for yourself how easy it is for your clients to give feedback.',
  openOnWebsite: 'Open BugHerd on your website',
  goToBoard: 'Go to your board',
  tryLaterHeading: 'Not seeing BugHerd on the page?',
  tryLaterButton: 'Skip for now →'
};

export const Type = typeof en;
